import React from "react";
import Text from "../../../common/typography/text";
import DropdownComponent from "../../../common/dropdown-input";
import TextInput from "../../../common/text-input";
import Button from "../../../common/button/button";

const formatCurrency = (value) => {
  const parsedValue = Number(value ?? 0);
  return Number.isFinite(parsedValue) ? parsedValue.toFixed(2) : "0.00";
};

const ShippingContent = ({
  shippingPreference,
  shippingPreferenceOptions,
  shippingPreferencePlaceholder,
  isShippingPreferenceDisabled,
  handleShippingPreferenceChange,
  isFedexShippingEnabled,
  fedexQuote,
  isLoadingFedexQuote,
  fedexQuoteError,
  onRetryFedexQuote,
  shippingContact,
  setShippingContact,
  shippingPreferenceCost,
  customPONumber,
  setCustomPONumber,
}) => {
  return (
    <>
      <Text variant="h1">Add Shipping Details</Text>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        <div className="field-group-wrapper">
          <div className="field-group-column">
            <DropdownComponent
              label="Shipping Preference"
              placeholder={shippingPreferencePlaceholder}
              isRequired
              isDisabled={isShippingPreferenceDisabled}
              options={shippingPreferenceOptions}
              value={shippingPreference}
              onChange={handleShippingPreferenceChange}
              parentClassname="full-width-button"
            />
            {isFedexShippingEnabled ? (
              <div
                className="direct-order-review-detail-content-text-container full-width-button"
                style={{ flexDirection: "column", alignItems: "flex-start", gap: "6px" }}
              >
                {isLoadingFedexQuote ? (
                  <Text variant="tinyText" color="lightText">
                    Fetching FedEx shipping rate...
                  </Text>
                ) : fedexQuoteError ? (
                  <>
                    <Text variant="tinyText" color="failureColor">
                      {fedexQuoteError}
                    </Text>
                    <Button
                      type="button"
                      variant="small-ghost"
                      onClick={onRetryFedexQuote}
                    >
                      Retry
                    </Button>
                  </>
                ) : fedexQuote ? (
                  <>
                    <Text variant="tinyText" color="lightText">
                      {fedexQuote?.packages?.length || 0} package
                      {(fedexQuote?.packages?.length || 0) === 1 ? "" : "s"} quoted
                    </Text>
                    {Array.isArray(fedexQuote?.warnings) &&
                      fedexQuote.warnings.length > 0 && (
                        <Text variant="tinyText" color="lightText">
                          {fedexQuote.warnings.join(" ")}
                        </Text>
                      )}
                  </>
                ) : (
                  <Text variant="tinyText" color="lightText">
                    Select a FedEx service to fetch a live rate.
                  </Text>
                )}
              </div>
            ) : null}
          </div>
          <div className="shipping-content-cost-container">
            <div className="direct-order-review-child-content-container">
              <div className="direct-order-review-detail-title-text-container">
                <Text variant="bodyText" color="lightText">
                  Shipping Cost
                </Text>
              </div>
              <div className="direct-order-review-detail-content-text-noflex-container">
                {shippingPreference && (!isFedexShippingEnabled || fedexQuote) && (
                  <Text variant="bodyText" color="lightText">
                    ${formatCurrency(shippingPreferenceCost || 0)}
                    {isFedexShippingEnabled && fedexQuote?.currency
                      ? ` ${fedexQuote.currency}`
                      : ""}
                  </Text>
                )}
              </div>
            </div>
            <Text variant="tinyText">
              Shipping only include Business Days M-F
            </Text>
          </div>
        </div>
        <Text variant="h2">Advanced Options (optional)</Text>
        <div className="field-group-wrapper">
          <div className="field-group">
            <TextInput
              titleText="Custom PO"
              placeholder="Enter custom PO"
              parentClassName="full-width-button"
              value={customPONumber}
              setValue={setCustomPONumber}
            />
          </div>
          <TextInput
            titleText="Shipping Contact"
            placeholder="Enter shipping contact"
            parentClassName="full-width-button"
            value={shippingContact}
            setValue={setShippingContact}
          />
        </div>
      </div>
    </>
  );
};

export default ShippingContent;
